import { Campaign, CampaignStatus } from '../types/campaign.interface';
import { EntityDefinition } from '../types/entity-definition.interface';

const CAMPAIGN_STATUS_I18N_OPTIONS = [
  { labelKey: 'entities.campaign.status.inProgress', value: CampaignStatus.ON_GOING },
  { labelKey: 'entities.campaign.status.completed', value: CampaignStatus.DONE },
  { labelKey: 'entities.campaign.status.cancelled', value: CampaignStatus.CANCELLED },
  { labelKey: 'entities.campaign.status.n1Validated', value: CampaignStatus.N1_VALIDATED },
];

export const campaignDefinition: EntityDefinition<Campaign> = {
  entityType: 'Campaign',
  i18nBase: 'entities.campaign',
  defaultSortField: 'timestamp',
  defaultSortOrder: -1,
  list: {
    columns: [
      // filterType routes any future rendering of this column to the shared date-range filter.
      {
        field: 'timestamp',
        headerKey: 'common.labels.date',
        sortable: true,
        filterable: true,
        template: 'date',
        filterType: 'datetime',
      },
      {
        field: 'assetId',
        headerKey: 'entities.asset.singular',
        storeType: 'Asset',
        displayField: 'name',
        template: 'tag',
        sortable: true,
        filterable: true,
      },
      {
        field: 'status',
        headerKey: 'common.labels.status',
        sortable: true,
        filterable: true,
        template: 'optionValue',
        options: CAMPAIGN_STATUS_I18N_OPTIONS,
      },
      { field: 'operator', headerKey: 'common.labels.operator', sortable: true, filterable: true },
      { field: 'isModel', headerKey: 'common.labels.model', template: 'boolean', sortable: true, filterable: true },
    ],
  },
  fields: [
    { field: 'timestamp', labelKey: 'entities.campaign.fields.date', required: true, type: 'datetime' },
    { field: 'operator', labelKey: 'common.labels.operator', required: false, type: 'text', maxLength: 100 },
    { field: 'comment', labelKey: 'common.labels.comment', required: false, type: 'textarea', maxLength: 500 },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.campaign.messages.createTitle',
      edit: () => 'entities.campaign.messages.editTitle',
      delete: () => 'entities.campaign.messages.deleteTitle',
    },
    buttons: {
      add: () => 'entities.campaign.messages.addButton',
      create: () => 'entities.campaign.messages.addButton',
      edit: () => 'entities.campaign.messages.editTitle',
      delete: () => 'entities.campaign.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.campaign.messages.deleteConfirm',
  },
  enableFiltering: true,
};
